// Динамический import: xlsx — тяжёлая библиотека (~835KB), грузим только когда
// реально нужна работа со списком фраз, а не на каждой странице приложения.

// Читает первую колонку первого листа. Заголовок здесь не отбрасывается:
// решение о нём принимает бэк (sanitizePhraseList), чтобы правило жило
// в одном месте.
export async function readPhraseColumn(file) {
  const XLSX = await import('xlsx');
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Не удалось прочитать файл'));
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'array' });
        const sheetName = wb.SheetNames[0];
        if (!sheetName) { resolve([]); return; }
        const rows = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { header: 1, blankrows: false });
        resolve(rows.map(row => (row && row.length ? row[0] : '')));
      } catch (err) {
        reject(new Error('Файл не похож на Excel: ' + err.message));
      }
    };
    reader.readAsArrayBuffer(file);
  });
}

// Выгрузка текущего списка обратно в xlsx — чтобы правку можно было
// начинать с того, что уже сохранено.
export async function downloadPhraseList(values, fileName) {
  const XLSX = await import('xlsx');
  const ws = XLSX.utils.aoa_to_sheet([['Фраза']].concat(values.map(v => [v])));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Фразы');
  XLSX.writeFile(wb, fileName + '.xlsx');
}

// То же самое, но для «желаемых»: читает вторую колонку как частотность.
export async function readPhraseRows(file) {
  const XLSX = await import('xlsx');
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Не удалось прочитать файл'));
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'array' });
        const sheetName = wb.SheetNames[0];
        if (!sheetName) { resolve([]); return; }
        const rows = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { header: 1, blankrows: false });
        resolve(rows.map(row => ({
          value: row && row.length ? row[0] : '',
          freq: row && row.length > 1 ? row[1] : '',
        })));
      } catch (err) {
        reject(new Error('Файл не похож на Excel: ' + err.message));
      }
    };
    reader.readAsArrayBuffer(file);
  });
}

// Выгрузка «желаемых» с частотностью — вторая колонка.
export async function downloadPhraseRows(rows, fileName) {
  const XLSX = await import('xlsx');
  const ws = XLSX.utils.aoa_to_sheet(
    [['Фраза', 'Частотность']].concat(rows.map(r => [r.value, r.freq === '' || r.freq === undefined ? '' : r.freq]))
  );
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Фразы');
  XLSX.writeFile(wb, fileName + '.xlsx');
}
